
      import { api } from './src/api.js';
      const statusEl = document.getElementById('api-status');
      const resultEl = document.getElementById('api-result');
      try {
        const [health, version] = await Promise.all([api.health(), api.version()]);
        statusEl.textContent = 'OK (' + health.status + ')';
        statusEl.className = 'status ok';
        resultEl.textContent = JSON.stringify({ health, version }, null, 2);
      } catch (e) {
        statusEl.textContent = 'ERROR: ' + e.message;
        statusEl.className = 'status err';
        resultEl.textContent = String(e.stack || e);
      }
    